import { jsx as _jsx } from "react/jsx-runtime";
import { ChakraProvider } from '@chakra-ui/react';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { StripeProvider } from '@client/providers/StripeProvider';
import { Auth0ProviderWithNavigate } from './providers/AuthProviderWithNavigate';
import { CategoriesProvider } from './providers/CategoriesProvider';
import { CheckoutStatusProvider } from './providers/CheckoutStatusProvider';
import { FavoritesProvider } from './providers/FavoritesProvider';
import { ShoppingCartProvider } from './providers/ShoppingCartProvider';
import { UserProvider } from './providers/UserProvider';
import customSystem from './theme';
const root = createRoot(document.getElementById('root'));
root.render(_jsx(React.StrictMode, { children: _jsx(BrowserRouter, { children: _jsx(Auth0ProviderWithNavigate, { children: _jsx(UserProvider, { children: _jsx(FavoritesProvider, { children: _jsx(CategoriesProvider, { children: _jsx(ShoppingCartProvider, { children: _jsx(CheckoutStatusProvider, { children: _jsx(ChakraProvider, { value: customSystem, children: _jsx(StripeProvider, { children: _jsx(App, {}) }) }) }) }) }) }) }) }) }) }));
